(function () {
  function lockScroll(on) {
    document.documentElement.classList.toggle('saha-drawer-open', on);
  }

  function setupDrawer(opts) {
    var root = document.querySelector(opts.selector);
    if (!root) return;

    function open() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      lockScroll(true);
      var input = root.querySelector(opts.focusSelector);
      if (input) window.setTimeout(function () { input.focus(); }, 120);
    }

    function close() {
      root.classList.remove('is-open');
      lockScroll(false);
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 320);
      var trigger = document.querySelector(opts.openSelector);
      if (trigger) trigger.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest(opts.openSelector)) {
        e.preventDefault();
        if (opts.selector === '[data-search-drawer]') {
          var mobileMenu = document.querySelector('[data-mobile-menu]');
          if (mobileMenu && mobileMenu.classList.contains('is-open')) {
            mobileMenu.classList.remove('is-open');
            mobileMenu.hidden = true;
            document.querySelectorAll('[data-mobile-menu-open]').forEach(function (b) {
              b.setAttribute('aria-expanded', 'false');
            });
          }
        }
        open();
      }
    });

    root.querySelectorAll(opts.closeSelector).forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    return { open: open, close: close };
  }

  setupDrawer({
    selector: '[data-mobile-menu]',
    openSelector: '[data-mobile-menu-open]',
    closeSelector: '[data-mobile-menu-close]',
    focusSelector: null
  });

  setupDrawer({
    selector: '[data-search-drawer]',
    openSelector: '[data-search-drawer-open]',
    closeSelector: '[data-search-drawer-close]',
    focusSelector: '[data-search-input]'
  });

  document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-mobile-menu-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    });
  });

  /* Mobile accordion submenus */
  document.querySelectorAll('[data-mobile-accordion]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : btn.nextElementSibling;

      document.querySelectorAll('[data-mobile-accordion]').forEach(function (other) {
        if (other === btn) return;
        other.setAttribute('aria-expanded', 'false');
        var otherId = other.getAttribute('aria-controls');
        var otherPanel = otherId ? document.getElementById(otherId) : other.nextElementSibling;
        if (otherPanel) otherPanel.hidden = true;
      });

      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  /* Desktop dropdowns: stay open while moving to submenu */
  (function setupNavDropdowns() {
    var items = document.querySelectorAll('[data-nav-dropdown]');
    if (!items.length) return;

    var closeTimers = new WeakMap();

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-nav-dropdown-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function openItem(item) {
      closeAll(item);
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-nav-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose(item) {
      var existing = closeTimers.get(item);
      if (existing) window.clearTimeout(existing);
      closeTimers.set(item, window.setTimeout(function () {
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-nav-dropdown-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }, 280));
    }

    function cancelClose(item) {
      var existing = closeTimers.get(item);
      if (existing) {
        window.clearTimeout(existing);
        closeTimers.delete(item);
      }
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-nav-dropdown-trigger]');

      item.addEventListener('mouseenter', function () {
        cancelClose(item);
        openItem(item);
      });

      item.addEventListener('mouseleave', function () {
        scheduleClose(item);
      });

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          /* First click opens; keep parent link reachable via second click while open */
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            openItem(item);
          }
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-dropdown]')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();
})();
